import React, { useEffect, useState } from "react";
import {
  Paper,
  InputBase,
  IconButton,
  Checkbox,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FilterSelect } from "../../Common/CustomSelectBox";
import styles from "./styles";

let searchTimeout = null;

const SearchBox = ({
  className,
  size,
  placeholder = "Search",
  handleSearch = () => {},
  onChange = () => {},
  multiple = true,
  fields = [],
  selectedFields = [],
  query = "",
  setLoader = () => {},
  width
}) => {
  const classes = styles();
  const [value, setValue] = useState("");
  const handleChange = ({ target: { value = "" } }) => {
    setValue(value);
    triggerSearch(value);
  };

  const triggerSearch = (val = "") => {
    clearTimeout(searchTimeout);
    setLoader(true);
    searchTimeout = setTimeout(() => {
      handleSearch(val.trim());
      setLoader(false);
    }, 1000);
  };

  useEffect(() => {
    setValue(query);
  }, [query]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(value);
      }}
    >
      <Paper className={classes.searchBar} style={{width: width ?? 200}}>
        <InputBase
          value={value}
          onChange={handleChange}
          className={classes.input}
          placeholder={placeholder}
        />

        {fields.length > 1 && (
          <FilterSelect
            multiple={multiple}
            fields={fields}
            selectedFields={selectedFields}
            onChange={onChange}
          />
        )}
        <IconButton
          className={classes.iconButton}
          aria-label="search"
          onClick={(e) => {
            handleSearch(value.trim());
          }}
          size="large">
          <SearchIcon className={classes.icon} />
        </IconButton>
      </Paper>
    </form>
  );
};

export default SearchBox;
